export interface BankAccount {
  id: string;
  name: string;
  bankName: string;
  bankAddress: string;
  accountName: string;
  accountNumber: string;
  sortCode: string;
  iban: string;
  swiftBic: string;
  domestic: boolean;
}

const ROWS: [keyof BankAccount, string][] = [
  ['bankName', 'Bank Name'],
  ['bankAddress', 'Bank address'],
  ['accountName', 'Account Name'],
  ['accountNumber', 'Account No.'],
  ['sortCode', 'Sort Code'],
  ['iban', 'IBAN'],
  ['swiftBic', 'SWIFT/BIC'],
];

export function bankLinesOf(account?: BankAccount): [string, string][] {
  if (!account) return [];
  return ROWS.flatMap(([key, label]) => {
    const value = String(account[key] || '').trim();
    return value ? [[label, value] as [string, string]] : [];
  });
}

export function chosenBank(accounts: BankAccount[], id: string): BankAccount | undefined {
  return accounts.find((row) => row.id === id) || accounts.find((row) => row.domestic) || accounts[0];
}

export function emptyBankAccount(): BankAccount {
  return {
    id: crypto.randomUUID(),
    name: 'New account',
    bankName: '',
    bankAddress: '',
    accountName: '',
    accountNumber: '',
    sortCode: '',
    iban: '',
    swiftBic: '',
    domestic: false,
  };
}
